
import React, { useState, useEffect, useLayoutEffect, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import logo2 from "./logo2.png";
import { firebase } from "../Firebase/config";


import { Particles as TsParticles } from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import { loadExternalRepulseInteraction } from 'tsparticles-interaction-external-repulse';


// eslint-disable-next-line
import { doc, getDoc, updateDoc, arrayUnion, query, collection, where, getDocs } from "@firebase/firestore";

import { Link } from "react-router-dom";
import "./App.css";
import NavBar from "./Navbar";

function App(props) {

  const { firstName, lastName } = props;

  const brightColors = ['#FFD700', '#FF6347', '#FF69B4', '#00BFFF', '#DA70D6', '#00FF7F', '#FFA500', '#FF1493', '#32CD32', '#FF4500'];
  
  const [particleColor] = useState(() => brightColors[Math.floor(Math.random() * brightColors.length)]);
  
  const [particleVersion] = useState(() => Math.floor(Math.random() * 2)); // 0 or 1 for random version on load
  const [particlesOptions, setParticlesOptions] = useState({});

  console.log(particleVersion, "This is the particle version");

  const particlesInit = async (main) => {
    await loadSlim(main);
    await loadExternalRepulseInteraction(main);
  };

  useEffect(() => {
    if (particleVersion === 0) {
      setParticlesOptions({
        background: {
          color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        },
        particles: {
          number: { value: 20 },
          shape: {
            type: 'character',
            options: {
              character: {
                fill: true,
                font: 'Verdana',
                weight: '900',
                value: ['Happy', 'Birthday', firstName || 'Friend']
              }
            }
          },
          size: { value: { min: 8, max: 15 } },
          links: {
            enable: true,
            distance: 150,
            color: particleColor,
            opacity: 0.4,
            width: 1,
            frequency: 1,
            blink: false
          },
          move: {
            enable: true,
            speed: 1,
            direction: 'none',
            random: false,
            straight: false,
            outModes: {
              default: 'bounce'
            },
            acceleration: {
              x: 0,
              y: 0
            }
          },
          trail: {
            enable: true,
            length: 5,
            fill: {}
          },
          opacity: { value: 0.9 },
          color: {
            value: particleColor
          },
          rotate: {
            value: { min: 0, max: 360 },
            animation: {
              enable: true,
              speed: 5,
              sync: false
            }
          },
          wobble: {
            distance: 10,
            enable: true,
            speed: {
              angle: 50,
              move: 10
            }
          }
        },
        interactivity: {
          events: {
            onHover: {
              enable: true,
              mode: 'bubble'
            },
            onClick: {
              enable: true,
              mode: 'push'
            }
          },
          modes: {
            bubble: {
              distance: 100,
              duration: 2,
              size: 2,
              opacity: 1
            },
            push: {
              quantity: 3
            }
          }
        }
      });
    } else {
      setParticlesOptions({
        background: {
          color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        },
        particles: {
          number: { value: 15 },
          shape: {
            type: 'character',
            options: {
              character: {
                fill: true,
                font: 'Verdana',
                weight: '900',
                value: ['Happy', 'Birthday', firstName || 'Friend']
              }
            }
          },
          size: { value: { min: 15, max: 25 } },
          links: {
            enable: true,
            distance: 200,
            color: particleColor,
            opacity: 0.4,
            width: 1,
            frequency: 1,
            blink: false
          },
          move: {
            enable: true,
            speed: 7,
            direction: 'none',
            random: true,
            straight: false,
            outModes: {
              default: 'bounce'
            }
          },
          opacity: { value: 0.9 },
          color: {
            value: particleColor
          },
          rotate: {
            value: { min: 0, max: 360 },
            animation: {
              enable: true,
              speed: 10,
              sync: false
            }
          }
        },
        interactivity: {
          events: {
            onHover: {
              enable: true,
              mode: 'bubble'
            },
            onClick: {
              enable: true,
              mode: 'push'
            }
          },
          modes: {
            bubble: {
              distance: 150,
              duration: 2,
              size: 30,
              opacity: 1
            },
            push: {
              quantity: 5
            }
          }
        }
      });
    }
  }, [particleVersion, particleColor, firstName, lastName]);

  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = !(
    location.pathname.includes("About") ||
    location.pathname.includes("Messages") ||
    location.pathname.includes("Classroom")
  );
  // eslint-disable-line no-unused-vars

  //with teacher access

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //without teacher access

  //   http://localhost:3000/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  // eslint-disable-next-line
  const { only2studentid, studentid, classid, language, id, role } = useParams();

  console.log("YESSS hwooo");

  const [nameofschoool, setNameofschool] = useState();
  const [nameofteacher, setNameofteacher] = useState();
  const [nameofclass, setNameofclass] = useState();
  // eslint-disable-next-line
  const [nameofstudent, setNameofstudent] = useState();

  const [studentidlocal, setstudentidlocal] = useState();

  const [viewparentpage, setViewparentpage] = useState(true);

  const [currenttotal, setCurrenttotal] = useState(0);

  const [newwidth, setNewwidth] = useState();

  // Donotshow is used to show the toggle icon that is only worth showing to teachers on the About page. So it is true everywhere but on about page.
  const [donotshow, setDonotshow] = useState();

  const [bringinmenu2, setBringinmenu2] = useState(false);
  const [temparray, setTemparray] = useState([]);

  const [objectofclass, setObjectofclass] = useState();




  //testing gif gmail sent begin






  useEffect(() => {
    console.log("Route pathname:", location.pathname);
    console.log("useParams:", { only2studentid, studentid, classid, language, id, role });

    const missing = [];
    if (!studentid) missing.push("studentid");
    if (!classid) missing.push("classid");
    if (!id) missing.push("id");

    if (missing.length) {
      console.warn("Missing required route params:", missing);

      // try to recover from localStorage (optional)
      const fallback = localStorage.getItem("currentclass") || localStorage.getItem("myclasses");
      if (fallback) {
        console.log("Found fallback in localStorage, continuing with fallback data");
        // optionally parse & initialize state here, e.g. setTemparray(JSON.parse(fallback)) etc.
        return;
      }

      // Otherwise redirect the user to a safe place
      navigate("/", { replace: true });
    }
  }, [only2studentid, studentid, classid, language, id, role, location.pathname]);
  // ...



  // useEffect(() => {
  //   setTimeout(() => {
  //     setBringinmenu2(true);
  //   }, 2);
  // }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setBringinmenu2(false);
  //   }, 1500);
  // }, []);




  return (
    <div className="App22">
      <TsParticles id="tsparticles" init={particlesInit} options={particlesOptions} />

      <div
        className="App"
        onClick={() => setBringinmenu2(!bringinmenu2)}
      >
      
      </div>

      {/* place button to call send gmail to mattkrebsemail@gmail.com api here */}


    </div>
  );
}

export default App;